import { useTranslation } from 'react-i18next';
import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import { useFormContext } from 'react-hook-form';
import { FormControl } from 'react-bootstrap';
import {
  RadioOptionsContainer,
  RadioIconsContainer,
} from './PropertyFeeModal.styles';
import useFormData from './useFormData';

interface AppliesToHostfullyFieldProps {
  labelInputSizes: {
    colSmLabel: number;
    colSmInput: number;
  };
}

const AppliesToHostfullyField = ({
  labelInputSizes,
}: AppliesToHostfullyFieldProps) => {
  const { t } = useTranslation();
  const { isRollInFeeIntoRent } = useFormData();
  const { setValue } = useFormContext();

  const handleChange = (e: React.FormEvent<FormControl>) => {
    const { value } = e.target as HTMLInputElement;

    if (value === 'NO' && isRollInFeeIntoRent) {
      setValue('rollsIntoRent', 'NO');
    }
  };

  return (
    <RadioOptionsContainer>
      <RadioGroupField
        horizontal
        name="appliesToHostfully"
        label={t(
          'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.appliesToHostfully',
        )}
        options={[
          { value: 'NO', label: t('common.no') },
          { value: 'YES', label: t('common.yes') },
        ]}
        onChangeHandler={handleChange}
        {...labelInputSizes}
      />
      <RadioIconsContainer>
        <HostfullyIcon />
      </RadioIconsContainer>
    </RadioOptionsContainer>
  );
};

export default AppliesToHostfullyField;
